import { getInstance } from '@portal/repositories/securitySdkConfig';

const BASE_URL = '/settings';

const SettingsApi = {
  get: async (): Promise<models.Settings> => {
    const instance = getInstance();
    const { data } = await instance.get<models.Settings>(BASE_URL);

    return data;
  },

  getRemoteConfig: async () => {
    const instance = getInstance();
    const { data } = await instance.get<{ app: models.RemoteConfig }>(
      `${BASE_URL}/remote-config`
    );

    return data.app;
  },

  getSacInformation: async () => {
    const instance = getInstance();
    const { data } = await instance.get<models.SettingsKeys>(`${BASE_URL}/sac`);

    return data;
  },
};

export default SettingsApi;
